
<template>
  <el-container style="padding:20px">
    <el-row justify="space-between" align="middle">
      <el-col>
        <h2>欢迎使用运输帮后台管理</h2>
      </el-col>
      <el-col>
        <div v-if="admin">
          当前管理员：<strong>{{ admin.username }}</strong>
          <el-button type="text" size="small" @click="onLogout">登出</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top:20px">
      <el-col :span="8">
        <el-card>
          <router-link to="/users">会员管理</router-link>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <router-link to="/admins">管理员管理</router-link>
        </el-card>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { ref } from 'vue'
import { parseToken } from '../api'

export default {
  name: 'Dashboard',
  setup () {
    const admin = ref(null)
    const token = localStorage.getItem('admin_token')
    if (token) {
      const p = parseToken(token)
      if (p) admin.value = { username: p.username || p.name || '' }
    }

    const onLogout = () => {
      localStorage.removeItem('admin_token')
      window.location.href = '/login'
    }

    return { admin, onLogout }
  }
}
</script>
